module.exports = __webpack_public_path__ + "static/media/NoActiveSprint.e139fa81.svg";